import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParrainageService {

  constructor(private http: HttpClient) { }

  // Récupérer la liste de tous les utilisateurs parrainés
  getSponsorships(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/sponsorship/all`, {'headers': headers});
  }

  getPaginatedSponsorships(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/sponsorship/all-paginated`+ (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }

  getAcceptedAndPaginatedSponsorships(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/sponsorship/all-accepted`+ (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }

  getPandindAndPaginatedSponsorships(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/sponsorship/all-panding`+ (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }

  getPaginatedSponsorshipsByDate(startDate: any, endDate: any, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/sponsorship/allbydates?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`, { headers: headers });
  }

  // Récupérer un filleul à partir de son ID
  getidSponsorshipById(idS: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/sponsorship/user/` + idS, {'headers': headers});
  }

  // Récupérer la liste de tous les parrainages
  listeParrains(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/sponsorship/allUserSponsor`, {'headers': headers});
  }

  // Récupérer un parrain à partir de son ID
  getidParrainsById(idS: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/sponsorship/user/` + idS, {'headers': headers});
  }

  deleteSponsorship(idS: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/sponsorship/` + idS, {'headers': headers});
  }

}
